class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
        renderUpsellComponent();
        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));

        // Start the timer when the cart drawer is opened
        this.startTimer();
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    var swiperContain = document.querySelector('.swiper-thumbs-contain');
    if (swiperContain) {
      const BackToTop = document.querySelector('#BackToTop');
      BackToTop.classList.remove('hidden');
      var overlay = document.querySelector('.overlay-thumbs');
      swiperContain.classList.remove('is-active');
      overlay.classList.remove('is-active');
      document.body.classList.remove('overflow-hidden-cs');
      var swiperActive = swiperContain.querySelector('.swiper-slide-active')
      const video = swiperActive.querySelector('video')
      var thumbsSlides = swiperContain.querySelectorAll('.swiper-slide');
      thumbsSlides.forEach(function (thumbsSlide) {
        const video = swiperActive.querySelector('video')
        video.pause();
        swiperActive.classList.remove('video-play')
      });
    }
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }

    this.drawer.openMenuDrawer();
  }

  startTimer() {
    function formatTime(minutes, seconds) {
      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    }

    function updateTimerDisplay(minutes, seconds) {
      const timerDisplay = $("#timerDisplay");
      timerDisplay.text(formatTime(minutes, seconds));
    }

    function timerCallback(minutes, seconds) {
      // Update the timer display
      updateTimerDisplay(minutes, seconds);

      // Restart the timer by calling the function recursively
      if (minutes === 0 && seconds === 0) {
        // If the timer reaches 0:00, restart the timer immediately
        timerCallback(30, 0);  // Restart with initial values (30 minutes)
      } else {
        // Decrement the seconds and adjust the minutes accordingly
        seconds = (seconds === 0) ? 59 : seconds - 1;
        minutes = (seconds === 59) ? minutes - 1 : minutes;

        // Continue the countdown
        setTimeout(function () {
          timerCallback(minutes, seconds);
        }, 1000);
      }
    }

    // Start the countdown when the cart drawer is opened
    timerCallback(30, 0);  // Initial values (30 minutes)
  }

  renderContents(parsedState) {
    var self = this;

    this.productId = parsedState.id;
    fetch("/cart.js")
      .then((result) => result.json())
      .then((result) => {
        giftHandle(result.total_price);
        self.getSectionsToRender().forEach((section) => {
          if (document.getElementById(section.id)) {
            document.getElementById(section.id).innerHTML =
              self.getSectionInnerHTML(
                parsedState.sections[section.id],
                section.selector
              );

            renderUpsellComponent();
          }
        });

        self.open();


      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);


async function fetchTotalPrice() {
    try {
        const response = await fetch('https://zybervr.com/cart.json');
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        const itemsSubtotalPrice = data.items_subtotal_price;
        console.log('Items Subtotal Price:', itemsSubtotalPrice);
        // Get the element
        const kitDetailsElement = document.querySelector('.kit-details');
        const kitValue = kitDetailsElement.getAttribute('data-kitvalue');
        const kitId = kitDetailsElement.getAttribute('data-kitid');
        console.log('Kit Value:', kitValue);
        console.log('Kit ID:', kitId);

        const bandDetailsElement = document.querySelector('.band-details');
        const bandValue = bandDetailsElement.getAttribute('data-bandvalue');
        const bandId = bandDetailsElement.getAttribute('data-bandid');
        console.log('Band Value:', bandValue);
        console.log('Band ID:', bandId);
      

      if (itemsSubtotalPrice > kitValue && itemsSubtotalPrice < bandValue ) {
          console.log('itemsSubtotalPrice > kitValue && itemsSubtotalPrice < bandValue ');
          addProduct(42594272706744, 1);
          removeProduct(43052014862520);
          reduceQuantitiesToOne([42594272706744, 43052014862520]);
        
      } 
      
      else if (itemsSubtotalPrice > kitValue && itemsSubtotalPrice > bandValue ) {
            console.log('itemsSubtotalPrice > kitValue && itemsSubtotalPrice > bandValue');
             addProducts([
              { id: 42594272706744, quantity: 1 },
              { id: 43052014862520, quantity: 1 }
            ]);
        reduceQuantitiesToOne([42594272706744, 43052014862520]);
        var checkoutButton = document.querySelector('.button_cart_checkout');
        setTimeout(() => {
          checkoutButton.removeAttribute('disabled');
          }, 1000);
      } 
      
      else if (itemsSubtotalPrice < kitValue && itemsSubtotalPrice < bandValue){
        console.log('itemsSubtotalPrice < kitValue && itemsSubtotalPrice < bandValue');
        // setTimeout(removeProducts([42594272706744, 43052014862520]),2000);
        setTimeout(() => {
        removeProduct(43052014862520);
          }, 500);
                  setTimeout(() => {
        removeProduct(42594272706744);
          }, 1000);
          reduceQuantitiesToOne([42594272706744, 43052014862520]);

      }
        else {
          console.log('no add no remove');
          setTimeout(() => {
          checkoutButton.removeAttribute('disabled');
          }, 1000);
        }
      
    } catch (error) {
        console.error('Error:', error);
        throw error; // Re-throw the error to handle it outside the function if needed
    }
}


let loaderTimeout;



async function addProducts(products) {
    $('.gift-loader').removeClass('hidden');
    try {
        const cart = await $.ajax({
            type: "GET",
            url: "/cart.js",
            dataType: "json",
        });

        console.log(cart, 'cart');

        // Filter out products that are already in the cart
        const itemsToAdd = products.filter(({ id }) => !cart.items.find(item => item.id == id));

        // If all products are already in the cart, display a message and exit
        if (itemsToAdd.length === 0) {
            console.log('All products are already in the cart');
            return;
          var checkoutButton = document.querySelector('.button_cart_checkout');
          setTimeout(() => {
            checkoutButton.removeAttribute('disabled');
            }, 1000);
        }

        // Otherwise, add the products that are not in the cart
        const requests = itemsToAdd.map(({ id, quantity }) => {
            return $.ajax({
                type: "POST",
                url: "/cart/add",
                dataType: "html",
                data: {
                    id: id,
                    quantity: quantity
                },
            });
        });

        await Promise.all(requests);

        updateMiniCart();
        // renderUpsellComponent();
        console.log('Products added to cart');
    } catch (error) {
        console.error('Error:', error);
    } finally {
        $('.gift-loader').addClass('hidden');
    }
}

async function removeProduct(id) {
  $('.gift-loader').removeClass('hidden');
  $.ajax({
    type: "POST",
    url: "/cart/update.js", // Use /cart/update.js endpoint to update the cart
    dataType: "json", // Expect JSON response
    data: {
      updates: {
        [id]: 0,
      }
    },
  }).then(() => {
    updateMiniCart();
    // renderUpsellComponent();
    $('.gift-loader').addClass('hidden');
    var checkoutButton = document.querySelector('.button_cart_checkout');
        console.log(checkoutButton,'checkoutButton hj');
        setTimeout(() => {
          checkoutButton.removeAttribute('disabled');
          }, 1500);
  });
}
async function removeProducts(ids) {
  $('.gift-loader').removeClass('hidden');
  console.log('all ones removed ');
  try {
    // Use Promise.all to wait for all AJAX requests to complete
    await Promise.all(ids.map(id => {
      return $.ajax({
        type: "POST",
        url: "/cart/update.js",
        dataType: "json",
        data: {
          updates: {
            [id]: 0,
          }
        },
      });
    }));
    // updateMiniCart();
    // renderUpsellComponent();
    $('.gift-loader').addClass('hidden');
  } catch (error) {
    console.error('Error:', error);
    $('.gift-loader').addClass('hidden');
  }
}
async function reduceQuantitiesToOne(productIds) {
    try {
        // Fetch the current cart data
        const cart = await $.ajax({
            type: "GET",
            url: "/cart.js",
            dataType: "json"
        });

        // Iterate over the array of product IDs
        productIds.forEach(async productId => {
            // Find the item with the specified productId in the cart
            const itemToUpdate = cart.items.find(item => item.id === productId);

            // If the item exists and its quantity is greater than one, update its quantity to one
            if (itemToUpdate && itemToUpdate.quantity > 1) {
                await $.ajax({
                    type: "POST",
                    url: "/cart/update.js",
                    dataType: "json",
                    data: {
                        updates: {
                            [itemToUpdate.key]: 1 // Set the quantity to one for the specified item
                        }
                    }
                });
                console.log(`Quantity reduced to one for product with ID ${productId}`);
            } else {
                console.log(`Product with ID ${productId} is either not in the cart or already has a quantity of one`);
            }
        });
    } catch (error) {
        console.error('Error:', error);
    }
}

// Usage: Call reduceQuantitiesToOne(productIds) with an array of product IDs you want to reduce the quantity for

async function addProduct(id, quantity) {
  $('.gift-loader').removeClass('hidden');
    $.ajax({
        type: "GET",
        url: "/cart.js",
        dataType: "json",
    }).then((cart) => {
      console.log(cart,'cart');
        const productInCart = cart.items.find(item => item.id == id);
        if (!productInCart) {
            $.ajax({
                type: "POST",
                url: "/cart/add",
                dataType: "html",
                data: {
                    id: id,
                    quantity: quantity
                },
            }).then(() => {
                updateMiniCart();
                // renderUpsellComponent();
                console.log('added not was in cart ');
                $('.gift-loader').addClass('hidden');
            });
        } else {
            console.log('Product is already in the cart');
          $('.gift-loader').addClass('hidden');
        }
    });
}

